"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccordionFooter = void 0;
const react_1 = __importDefault(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const AccordionFooter = ({ className, style, children, }) => {
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)('_ef987f19', '_1a63a569', '_pub-1a63a569', '_pub-aba6f5bf', className), style: style }, children));
};
exports.AccordionFooter = AccordionFooter;
//# sourceMappingURL=AccordionFooter.js.map